
import { Component, Vue, Prop } from 'vue-property-decorator'
import katex from 'katex'
import 'katex/dist/katex.min.css'

/**
 * latex形式の文字列をhtml上で文字列として表示する(katex)
 */
@Component
export default class KatexText extends Vue {
  /** latex形式文字列 */
  @Prop()
  private src!: string

  /**
   * katexを使用してhtmlに変換した文字列を返す
   *
   * @returns html文字列
   */
  private katexHtml(): string {
    return katex.renderToString(this.src, { strict: false })
  }
}
